
<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">
        <v-card-title  class="p-1">
          <v-chip
              label    small
              class="ma-2"
              color="secondary">
            درخواست تایید قالب پیام
          </v-chip>
          <v-spacer/>
          <v-btn light icon @click="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>


          <v-form ref="form"  lazy-validation v-model="valid">
            <v-row>

                <v-col
                    cols="12"
                    sm="3">
                  <label ><span style="color: #000000;">مجتمع:</span><span > {{model.building}}</span></label>
                </v-col>
              <v-col cols="12"
                     sm="3" v-if="model.templateType==='GENERAL'"
              >
                <label> <span style="color: #000000;">موضوع:</span>  {{ model.subjectText }}</label>
              </v-col>
              <v-col v-if="model.templateType==='GENERAL'"
                    cols="12"
                    sm="3">
                  <label ><span style="color: #000000;">نام قالب به انگلیسی:</span><span > {{model.templateEn}}</span></label>
                </v-col>


              <v-col
                  cols="12"
                  sm="3">
                <label ><span style="color: #000000;">نام قالب به فارسی:</span><span > {{model.templateFa}}</span></label>
              </v-col>
              <v-col  v-if="model.templateType==='GENERAL'"
                  cols="12"
                  sm="3"
              >
                <label ><span style="color: #000000;">تعداد ستون اکسل:</span><span > {{model.countCell}}</span></label>

              </v-col>
              <v-col  v-if="model.templateType==='DAILY_ACCOUNT'"
                  cols="12"
                  sm="3"
              >
                <label ><span style="color: #000000;">نوع مخاطب:</span><span > {{model.audienceType}}</span></label>

              </v-col>

              <v-col
                  cols="12"
                  sm="12"
              >
                <v-card elevation="0" >
                  <span style="color: #000000;">متن پیام:</span><span > {{model.message}}</span>
                  <v-card-actions dir="ltr">
                      <span  style="float: left!important;font-size: 11px!important;" class="text-caption black--text">
                  تعداد کاراکتر: {{ messageStats.length }} |
                  تعداد پیامک: {{ messageStats.smsCount }}
                </span>
                  </v-card-actions>
                </v-card>



              </v-col>

              <v-col
                  cols="12"
                  sm="12"
              >

                <v-textarea
                    :rows="1"
                    label="توضیحات"
                    outlined
                    dense
                    v-model="descripiton"
                />

              </v-col>
            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" pr-1 pl-1"
                 @click="confirm(true)"
                  :loading="loading"
              >
                تایید
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="unConfirm(false)"
              >
               عدم تایید
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Servise_se from "./Servise_se.js";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      descripiton:'',
      loading: false,
      valid: true,

    }
  },


  methods: {

    closed() {
      this.loading = false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('RequestTemplateSmsManager')
    },


    confirm() {
      this.loading = true
      Servise_se.confirm(this.model.id,this.descripiton).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading = false
        }
      })

    },
    unConfirm() {
      this.loading = true
      Servise_se.unConfirm(this.model.id,this.descripiton).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading = false
        }
      })

    },

  },

  computed: {
    messageStats() {
      const message = this.model.message || '';
      const length = message.length;

      // تخمین تعداد پیامک بر اساس طول پیام (فرض: فارسی، 70 کاراکتر اول، بعدش 67تایی)
      let smsCount = 0;
      if (length > 0) {
        if (length <= 70) {
          smsCount = 1;
        } else {
          smsCount = Math.ceil((length - 70) / 67) + 1;
        }
      }

      return {
        length,
        smsCount
      };
    }
  }

}
</script>


